module.exports = __webpack_public_path__ + "img/mescroll-empty.1717743559951.png";